const convertErrorsToObject = (errors) => {
  const output = {};

  Object.keys(errors).forEach((key) => {
    const keyParts = key.split('.');
    let current = output;

    for (let i = 0; i < keyParts.length - 1; i += 1) {
      if (!current.hasOwnProperty(keyParts[i])) {
        current[keyParts[i]] = {};
      }
      if (typeof current[keyParts[i]] !== 'object') {
        current[keyParts[i]] = {
          _:  current[keyParts[i]],
        };
      }

      current = current[keyParts[i]];
    }

    current[keyParts[keyParts.length - 1]] = errors[key];
  });

  return output;
};

export default convertErrorsToObject;
